import React, { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'; // legacy build for better browser support
import PlusIcon from 'assets/img/icons/PlusIcon';
import PlusIconOutlined from 'assets/img/icons/PlusIconOutlined';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;

interface PdfUploadComponentProps {
  onParsedPdf?: (parsedText: string) => void;
}

const PdfUploadComponent = ({ onParsedPdf }: PdfUploadComponentProps) => {
  const [hovered, setHovered] = useState(false);
  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.type !== 'application/pdf') {
      alert('Please upload a valid PDF file.');
      return;
    }

    const reader = new FileReader();
    reader.onload = async () => {
      try {
        const arrayBuffer = reader.result as ArrayBuffer;
        const text = await parsePdf(arrayBuffer);
        onParsedPdf?.(text);
      } catch (error) {
        console.error('Error parsing PDF:', error);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const parsePdf = async (buffer: ArrayBuffer): Promise<string> => {
    const pdf = await pdfjsLib.getDocument({ data: new Uint8Array(buffer) }).promise;
    let extractedText = '';

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const textContent = await page.getTextContent();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const line = textContent.items.map((item: any) => item.str.trim()).join(' ');
      extractedText += line.replace(/\s+/g, ' ').trim() + '\n';
    }

    return extractedText;
  };

  return (
    <Box>
      <Tooltip title="Add files" arrow>
        <IconButton
          component="label"
          aria-label="upload pdf"
          sx={{
            width: 40,
            height: 40,
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {hovered ? <PlusIconOutlined /> : <PlusIcon />}
          <input type="file" accept="application/pdf" hidden onChange={handleFileUpload} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default PdfUploadComponent;
